import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiBell, FiMail, FiUser, FiLogOut } from "react-icons/fi";
import { authFetch, logout } from "../api";

function DropdownPanel({ children }) {
  return (
    <div className="absolute right-0 top-full mt-2 w-72 bg-navy-dark border border-navy-border rounded-lg shadow-xl z-50 overflow-hidden">
      {children}
    </div>
  );
}

export default function AdminTopBar() {
  const [openMenu, setOpenMenu] = useState(null); // 'notifications' | 'messages' | 'profile' | null
  const [profile, setProfile] = useState(null);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    authFetch("/core/profile/")
      .then((res) => res.json())
      .then(setProfile)
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggle = (menu) => setOpenMenu((current) => (current === menu ? null : menu));

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const initial = (profile?.email || profile?.username || "?").charAt(0).toUpperCase();

  return (
    <header className="h-16 shrink-0 flex items-center justify-end gap-2 px-6 bg-navy border-b border-navy-border">
      <div ref={containerRef} className="flex items-center gap-2">
        <div className="relative">
          <button
            onClick={() => toggle("notifications")}
            className="w-10 h-10 flex items-center justify-center rounded-lg text-gray-300 hover:bg-white/5 hover:text-white transition-colors"
            aria-label="Notifications"
          >
            <FiBell size={18} />
          </button>
          {openMenu === "notifications" && (
            <DropdownPanel>
              <div className="px-4 py-3 border-b border-navy-border font-semibold text-sm">Notifications</div>
              <div className="px-4 py-6 text-sm text-gray-400 text-center">No new notifications</div>
            </DropdownPanel>
          )}
        </div>

        <div className="relative">
          <button
            onClick={() => toggle("messages")}
            className="w-10 h-10 flex items-center justify-center rounded-lg text-gray-300 hover:bg-white/5 hover:text-white transition-colors"
            aria-label="Messages"
          >
            <FiMail size={18} />
          </button>
          {openMenu === "messages" && (
            <DropdownPanel>
              <div className="px-4 py-3 border-b border-navy-border font-semibold text-sm">Messages</div>
              <div className="px-4 py-6 text-sm text-gray-400 text-center">No new messages</div>
            </DropdownPanel>
          )}
        </div>

        <div className="relative">
          <button
            onClick={() => toggle("profile")}
            className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-lg text-gray-200 hover:bg-white/5 transition-colors"
          >
            <span className="w-8 h-8 rounded-full bg-brand-gradient flex items-center justify-center text-sm font-semibold text-white">
              {initial}
            </span>
            <span className="text-sm font-medium max-w-[140px] truncate">
              {profile?.email || "Account"}
            </span>
          </button>
          {openMenu === "profile" && (
            <DropdownPanel>
              <div className="px-4 py-3 border-b border-navy-border">
                <p className="text-sm font-semibold truncate">{profile?.email}</p>
                <p className="text-xs text-gray-400">Signed in</p>
              </div>
              <button
                onClick={() => { setOpenMenu(null); navigate("/admin/profile"); }}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-300 hover:bg-white/5 hover:text-white transition-colors"
              >
                <FiUser size={16} /> Profile
              </button>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-300 hover:bg-red-500/10 hover:text-red-400 transition-colors"
              >
                <FiLogOut size={16} /> Logout
              </button>
            </DropdownPanel>
          )}
        </div>
      </div>
    </header>
  );
}
